/* eslint-disable react-hooks/exhaustive-deps */
import React, { Key, useImperativeHandle, useRef, useState } from 'react';
import { TreeNode } from 'src/components/Tree/type';
import { Flex } from '@tonic-one/react';
import { useWhyDidYouUpdate } from 'src/utils/hooks';
import CasTreeTransfer, {
  TransferLeftBox,
} from 'src/components/CasTreeTransfer';
import CSpinner from 'src/components/CSpinner';
import cloneDeep from 'lodash/cloneDeep';
import { disableCheckboxAllTargetGroup } from '../../utils/fns';
export interface TargetUserGroupsProps {
  getAllTargets: (isPagination?: boolean) => Promise<void>;
  getSpecificTarget: (expandKeys: string[]) => Promise<void>;
  handleToRight: (keys: Key[]) => void;
  handleDeleteTarget: (key: Key) => void;
  syncTargets: (isPagination?: boolean) => Promise<void>;
  allTargets: TreeNode[];
  policyTarget: TreeNode[];
  searchTargetResult?: TreeNode[];
  searchTarget?: (value: string) => Promise<TreeNode[]>;
}

export interface TransferChildRef {
  checkedKeys: TreeNode[];
}

const defaultValueForTransfer: React.Key[] = [];
export const SingleTargetUserGroups = React.forwardRef(
  (props: TargetUserGroupsProps, ref) => {
    const {
      getAllTargets,
      getSpecificTarget,
      allTargets,
      policyTarget,
      searchTarget,
      searchTargetResult,
    } = props;
    const childRef = useRef<TransferChildRef | null>(null);
    useImperativeHandle(
      ref,
      (): {
        checkedKeys: TreeNode[];
      } => ({
        // 暴露的属性
        checkedKeys,
      })
    );
    const [checkedKeys, setCheckedKeys] = React.useState<TreeNode[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const isBrightRight = React.useMemo(
      () => checkedKeys.length > 0,
      [checkedKeys]
    );
    const handleExpand = React.useCallback(
      async (expandKeys: string[]) => {
        setLoading(true);
        await getSpecificTarget(expandKeys);
        setLoading(false);
      },
      [getSpecificTarget]
    );
    const handleCheckedKeysChange = React.useCallback((entries: TreeNode[]) => {
      const users = entries.filter((item) => item.icon?.name === 'user');
      console.log('handleCheckedKeysChange', entries, 'users', users);
      setCheckedKeys(users);
    }, []);
    const showData = React.useMemo(() => {
      const isSearchResult = searchTargetResult
        ? searchTargetResult.length > 0
        : false;
      const base =
        isSearchResult && searchTargetResult ? searchTargetResult : allTargets;
      // CAS-4076: Disable checkbox for group nodes, only allow selecting individual users
      return disableCheckboxAllTargetGroup(cloneDeep(base));
    }, [allTargets, searchTargetResult]);
    useWhyDidYouUpdate('TargetUserGroups', {
      allTargets,
      policyTarget,
      checkedKeys,
      isBrightRight,
    });
    React.useEffect(() => {
      setLoading(true);
      getAllTargets(true).then(() => {
        setLoading(false);
      });
    }, []);
    return (
      <Flex direction="column">
        {loading && <CSpinner />}
        <Flex alignItems="center" justify="space-between" ref={childRef}>
          {/* defaultValue always be [] for init. For new add policy, it will be [] naturally. For exised policy, some targets are not expanded in available targets, it will be not found, put these targets in defaultValue will cause an error  */}
          <CasTreeTransfer defaultValue={defaultValueForTransfer} isLeftOnly>
            <TransferLeftBox
              treeData={showData as TreeNode[]}
              onExpand={handleExpand}
              handleSelectedItemsChange={handleCheckedKeysChange}
              onSearch={searchTarget}
            />
          </CasTreeTransfer>
        </Flex>
      </Flex>
    );
  }
);
